import axios, { Axios } from "axios";
import Request from "./Request.js";
export class ApiClientBase {
    axios;
    defaultRequestOptions = {};
    constructor(axiosConfig = axios) {
        this.axios =
            axiosConfig instanceof Axios ? axiosConfig : axios.create(axiosConfig);
    }
    buildRequestOptions(fromRequest) {
        return {
            ...this.defaultRequestOptions,
            ...fromRequest,
        };
    }
    requestFunctionFactory(operation) {
        return (conf, opts = {}) => {
            const { onBeforeRequest } = this.buildRequestOptions(opts);
            const request = new Request(operation, conf);
            if (onBeforeRequest) {
                onBeforeRequest(request);
            }
            return request.execute(this.axios);
        };
    }
}
export default ApiClientBase;
